// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.getcard-container-get {
  padding: 40px 20px;
  background-color: #000;
  color: white;
}

.getcard-heading-get {
  text-align: center;
  font-size: 3.5rem;
  margin-bottom: 40px;
  font-weight: bold;
}

.getcard-heading-get span {
  color: #BA1E24;
}

.cards-container-get {
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding: 20px 0;

}

/* Hide scrollbar for Chrome, Safari and Opera */
.cards-container-get::-webkit-scrollbar {
  display: none;
}

.card-get {
  min-width: 300px;
  max-height: 400px;
  background: white;
  overflow: hidden;
  transition: transform 0.3s ease;
  cursor: pointer;
  position: relative;
  border-radius: 0;
  border: 2px solid black;
}

.card-get:hover {
  transform: translateY(-5px);
}

.card-get img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.card-content-get {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  padding: 15px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  background: none;
}

.card-content-get h2 {
    font-weight: 800;
  font-size: 36px;
  line-height: 96%;
  margin-bottom: 5px;
  font-weight: bold;
  color: white;
}

.card-content-get p {
    font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  /* font-family: "Montserrat"; */
}

/* Make it responsive */
@media (max-width: 768px) {
  .getcard-container-get {
    padding: 40px 20px;
  }

  .getcard-heading-get {
    font-size: 36px;
  }

  .cards-container-get {
    padding: 10px 0;
  }

  .card-get {
    min-width: 250px;
  }

  .card-content-get h2 {
    font-size: 24px;
    padding-bottom: 10px;
  }
  .card-content-get p {
    padding-bottom: 50px;
  }
}

@media (max-width: 480px) {
  .getcard-heading-get {
    font-size: 2rem;
  }
  
  .card-get {
    min-width: 200px;
    max-height: 300px;
  }
  
  .card-content-get {
    padding: 10px;
    top: 5px;
  }
  
  .card-content-get h2 {
    font-size: 1rem;
  }
  
  .card-content-get p {
    font-size: 0.6rem;
    padding-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/newSeason/getcard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;;AAEjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;IACI,gBAAgB;EAClB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":[".getcard-container-get {\n  padding: 40px 20px;\n  background-color: #000;\n  color: white;\n}\n\n.getcard-heading-get {\n  text-align: center;\n  font-size: 3.5rem;\n  margin-bottom: 40px;\n  font-weight: bold;\n}\n\n.getcard-heading-get span {\n  color: #BA1E24;\n}\n\n.cards-container-get {\n  display: flex;\n  overflow-x: auto;\n  gap: 20px;\n  padding: 20px 0;\n\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.cards-container-get::-webkit-scrollbar {\n  display: none;\n}\n\n.card-get {\n  min-width: 300px;\n  max-height: 400px;\n  background: white;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  border-radius: 0;\n  border: 2px solid black;\n}\n\n.card-get:hover {\n  transform: translateY(-5px);\n}\n\n.card-get img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.card-content-get {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  right: 20px;\n  padding: 15px;\n  color: white;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n  background: none;\n}\n\n.card-content-get h2 {\n    font-weight: 800;\n  font-size: 36px;\n  line-height: 96%;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: white;\n}\n\n.card-content-get p {\n    font-weight: 400;\n  font-size: 13px;\n  line-height: 140%;\n  /* font-family: \"Montserrat\"; */\n}\n\n/* Make it responsive */\n@media (max-width: 768px) {\n  .getcard-container-get {\n    padding: 40px 20px;\n  }\n\n  .getcard-heading-get {\n    font-size: 36px;\n  }\n\n  .cards-container-get {\n    padding: 10px 0;\n  }\n\n  .card-get {\n    min-width: 250px;\n  }\n\n  .card-content-get h2 {\n    font-size: 24px;\n    padding-bottom: 10px;\n  }\n  .card-content-get p {\n    padding-bottom: 50px;\n  }\n}\n\n@media (max-width: 480px) {\n  .getcard-heading-get {\n    font-size: 2rem;\n  }\n  \n  .card-get {\n    min-width: 200px;\n    max-height: 300px;\n  }\n  \n  .card-content-get {\n    padding: 10px;\n    top: 5px;\n  }\n  \n  .card-content-get h2 {\n    font-size: 1rem;\n  }\n  \n  .card-content-get p {\n    font-size: 0.6rem;\n    padding-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
